export default __webpack_public_path__ + "static/media/pie-light.928a8898.svg";